import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
// import Login from '../views/user/login.vue'
import DoctorList from '../views/staff/index.vue'
import DoctorDetails from '../views/staff/detail.vue'
import agreementPage from '../views/user/agreement.vue'
import wxconfig from '../utils/wxconfig.js';
import pageread from '../utils/pageread.js';
import ParentRouter from './Router'
import PageIndex from '../views/page/PageIndex'
import cookie from "vue-cookies"

import i18n from 'vue-i18n';

Vue.use(VueRouter)

// console.log(Vue);
// 全局导航守卫
// router.beforeEach((to, from, next) => {
//   if (to.path === '/login' || to.path === '/' || to.path === '/gocc') {
//     return next()
//   }
//   next()
// })

const router = new VueRouter({
    routes: [{
            path: '/',
            // name: 'Index',
            component: ParentRouter,
            children: [{
                path: "/",
                component: PageIndex
            }, {
                path: 'Index',
                name: 'Index',
                component: Index
            }, {
                path: 'page',
                name: 'page',
                component: PageIndex
            }]
        },
        {
            path: "/dcm",
            // name: "dcm",
            component: ParentRouter,
            children: [{
                    path: '/',
                    component: () =>
                        import ("@/views/dcm/index")
                },
                {
                    path: 'argeement',
                    component: () =>
                        import ("@/views/dcm/argeement")
                }
            ]
        },
        {
            path: "/pdfView",
            component: () =>
                import ("@/views/pe/pdfView")
        },
        {
            path: "/sukangbao/download",
            component: () =>
                import ("@/views/download/index")
        },
        {
            path: '/cs',
            component: () =>
                import ("@/views/cs")
        },
        {
            // 文登的 
            path: "/wx-gzh/wenddeng",
            component: () =>
                import ("@/views/my/WDemergencyContact")
        },
        {
            path: '/404',
            name: "404",
            component: () =>
                import ('@/views/404'),
            hidden: true
        },
        {
            path: "/followup",
            name: "followup",
            component: ParentRouter,
            children: [{
                path: "messageCenter",
                component: () =>
                    import ("@/views/messageCenter/index")
            }, {
                path: "notice-detail",
                component: () =>
                    import ("@/views/messageCenter/reminddetails")
            }, {
                path: "index",
                component: () =>
                    import ("@/views/followUp/index")
            }, {
                path: "followdetails",
                component: () =>
                    import ("@/views/followUp/details"),
                meta: {
                    // title:VueI18n.$t("followUp.followDetails"),
                }
            }]
        },
        {
            path: "/subscribeHospital",
            component: ParentRouter,
            children: [{
                path: "addSubscribe",
                component: () =>
                    import ("@/views/subscribeHospital/addSubscribe.vue")
            }, {
                path: "result",
                component: () =>
                    import ("@/views/subscribeHospital/details")
            }, {
                path: "index",
                component: () =>
                    import ("@/views/subscribeHospital/index.vue")
            }]
        },
        {
            path: "/admission",
            component: ParentRouter,
            children: [{
                path: "index",
                component: () =>
                    import ("@/views/admission/index"),
            }, {
                path: "add",
                component: () =>
                    import ("@/views/admission/addAdmission")
            }, {
                path: "details",
                component: () =>
                    import ("@/views/admission/details")
            }]
        },
        {
            path: '/questionaire',
            component: ParentRouter,
            children: [{
                    path: 'go-questionaire',
                    component: () =>
                        import ('@/views/questionaire/Questionaire.vue')
                },
                {
                    path: 'questionaire',
                    component: () =>
                        import ('@/views/questionaire/Questionaire.vue')
                },
                {
                    path: 'after',
                    component: () =>
                        import ('@/views/questionaire/afterSubmit.vue')
                }
            ]
        },
        {
            // 流调
            path: "/currentRegulation",
            meta: { title: "流调" },
            component: () =>
                import ("@/views/currentRegulation/index")
        },
        {
            // 量表 
            path: '/ratingScale',
            component: ParentRouter,
            children: [{
                    path: 'collectRatingScale',
                    component: () =>
                        import ('@/views/ratingScale/collectRatingScale')
                },{
                    path:"after",
                    component: () =>
                        import ('@/views/ratingScale/afterSubmit')
                }
            ]
        },
        {
            // 用药
            path: '/useMedicine',
            component: ParentRouter,
            children: [{
                    path: 'index',
                    component: () =>
                        import ('@/views/useMedicine/index')
                },
                {
                    path:"details",
                    component: () =>
                        import ('@/views/useMedicine/details')
                }
            ]
        },
        {
            path: "/patient",
            component: ParentRouter,
            children: [{
                    path: "add",
                    component: () =>
                        import ("@/views/patient/add")
                },
                {
                    path: "index",
                    component: () =>
                        import ("@/views/patient/list")
                },
                {
                    path: 'editBind',
                    component: () =>
                        import ("@/views/patient/editBind")
                },
                {
                    path: 'edit',
                    component: () =>
                        import ("@/views/patient/add")
                },
                {

                    path: "HRPatientDetails",
                    component: () =>
                        import ("@/views/patient/HRPatientDetails")
                },
                {
                    path: "addHeathly",
                    component: () =>
                        import ("@/views/patient/addHrHeathly")
                },
                {
                    path: "patientDetails",
                    component: () =>
                        import ("@/views/patient/patientDetails")
                }, {
                    path: "medicalRecordsDetails",
                    component: () =>
                        import ("@/views/patient/medicalRecordsDetails")
                }, {
                    path: "casehistorydetails",
                    component: () =>
                        import ("@/views/patient/casehistorydetails")
                }, {
                    path: "addcustomcaseHistory",
                    component: () =>
                        import ("@/views/patient/addcustomcaseHistory")
                }, {
                    path: "imageData",
                    component: () =>
                        import ("@/views/patient/imageData")
                }, {
                    path: "patientRecord",
                    component: () =>
                        import ("@/views/patient/patientRecord")
                },{
                    path:"selectPatient",
                    component: () =>
                        import ("@/views/patient/selectPatient")
                }
            ]
        },
        {
            path: '/bloodPressure',
            component: ParentRouter,
            children: [{
                path: "index",
                component: () =>
                    import ("@/views/monitor/index")
            }, {
                path: "add",
                component: () =>
                    import ("@/views/monitor/addMonitor")
            }]

        },
        {
            path:"/historyMedication",
            component:ParentRouter,
            children:[
                {
                    path:"index",
                    component: () =>
                        import ("@/views/historyMedication/index")
                },
                {
                    path:"addOrEdit",
                    component: () =>
                        import ("@/views/historyMedication/addOrEdit")
                }
            ]
        },
        // 我的优惠券
        {
            path:"/myCoupon",
            component:ParentRouter,
            children:[
                {
                    path:"index",
                    component: () =>
                        import ("@/views/myCoupon/index")
                },
                {
                    path:"receive",
                    component:()=> import("@/views/myCoupon/receive")
                }
            ]
        },
      
        {
            // 放疗
            path: "/radiotherapy",
            component: ParentRouter,
            children: [{
                path: "index",
                component: () =>
                    import ("@/views/radiotherapy/index")
            }, {
                path: "detail",
                component: () =>
                    import ("@/views/radiotherapy/detail")
            }, {
                // 放疗消息
                path: "msg",
                component: () =>
                    import ("@/views/radiotherapy/msg")
            }]
        },
        {
            path: '/im',
            component: ParentRouter,
            children: [{
                    path: 'go-cc',
                    component: () =>
                        import ('@/views/im/Chat.vue')
                        // import ('@/views/im/Chat.vue')
                },
                {
                    path: 'go-dc/:toUserId',
                    component: () =>
                        import ('@/views/im/GoDC.vue')
                        // import ('@/views/im/Chat.vue')
                },
                {
                    path: 'chat-list',
                    component: () =>
                        import ('@/views/im/ChatList.vue')
                },
                {
                    path: 'chat',
                    component: () =>
                        import ('@/views/im/Chat.vue')
                }, {
                    // 群成员
                    path: "groupList",
                    component: () =>
                        import ('@/views/im/groupList.vue')
                }
            ]
        }, {
            path: "/promotion",
            component: ParentRouter,
            children: [{
                path: 'index',
                component: () =>
                    import ('@/views/promotion/index')
            }, {
                path: 'wx',
                component: () =>
                    import ('@/views/promotion/wx')
            }, {
                path: "wx-share",
                component: () =>
                    import ("@/views/promotion/wxShare")
            }, {
                path: 'wxApps',
                component: () =>
                    import ('@/views/promotion/activity_ios_andriod')
            },{
                  // 兑换详情
                path:"exchangeDetails",
                component:()=> import("@/views/promotion/exchangeDetails")
            }]
        }, {
            path: "/pe",
            component: ParentRouter,
            children: [{
                    path: 'list',
                    component: () =>
                        import ('@/views/pe/medicalReportList')
                },

                {
                    path: 'compare',
                    component: () =>
                        import ('@/views/pe/contrastList')
                },
                {
                    path: 'compare-detail',
                    component: () =>
                        import ('@/views/pe/contrastDetails')
                },
                {
                    path: "detail",
                    component: () =>
                        import ('@/views/pe/medicalReportDetails')
                },
            ]
        },
        {
            path: "/shop",
            component: ParentRouter,
            children: [{
                    path: "home",
                    name: "shopHome",
                    component: PageIndex
                }, {
                    path: "goods-list",
                    component: () =>
                        import ('@/views/shop/goods/list')
                }, {
                    path: "optional",
                    component: () =>
                        import ("@/views/optional/index")
                }, {
                    path: "suppermarket",
                    component: () =>
                        import ("@/views/optional/selectProject")
                },
                {
                    path: "goods-detail",
                    component: () =>
                        import ('@/views/shop/goods/goodsDetails')
                }, {
                    path: "create-order",
                    component: () =>
                        import ('@/views/shop/goods/createOrder')
                }, {
                    path: "cs",
                    component: () =>
                        import ('@/views/shop/goods/cs')
                }, {
                    path: "address-list",
                    component: () =>
                        import ('@/views/shop/address/addressList')
                }, {
                    path: "address-addOrEdit",
                    component: () =>
                        import ('@/views/shop/address/addOrEdit')
                }, {
                    path: "shopping-cart",
                    component: () =>
                        import ("@/views/shop/goods/shoppingCart")
                },
                {
                    path: "myorder-list",
                    component: () =>
                        import ("@/views/my/myOrderList")
                }, {
                    path: "order-detail",
                    component: () =>
                        import ("@/views/my/orderDetails")
                }, {
                    path: "personal",
                    component: () =>
                        import ("@/views/my/personal")
                }, {
                    path: "personal-detail",
                    component: () =>
                        import ("@/views/my/peosonalDetail")
                },
            ]
        },
        {
            path: "/paysuccess",
            component: () =>
                import ("@/views/shop/paysuccess")
        },
        {
            path: "/my",
            component: ParentRouter,
            children: [{
                path: "/",
                // name: 'article',
                component: () =>
                    import ("@/views/my/personal"),
            }, {
                path: "personal-detail",
                component: () =>
                    import ("@/views/my/peosonalDetail")
            }, {
                path: "wallet",
                component: () =>
                    import ("@/views/my/myWallet")
            }, {
                path: "WithdrawalRecord",
                component: () =>
                    import ("@/views/my/WithdrawalRecord")

            }, {
                path: "WithdrawalList",
                component: () =>
                    import ("@/views/my/WithdrawalList")
            }, {
                path: "applyForwallet",
                component: () =>
                    import ("@/views/my/applyForwallet")
            }, {
                path: "Integral",
                component: () =>
                    import ("@/views/my/MyIntegral")
            }, {
                path: "evaluate",
                component: () =>
                    import ("@/views/my/evaluate")
            }, {
                path: "editEvalute",
                component: () =>
                    import ("@/views/my/editEvalute")
            }, {
                path: "evalute_success",
                component: () =>
                    import ("@/views/my/evalute_success")
            }, ]
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: ParentRouter,
            children: [{
                path: "add",
                component: () =>
                    import ("@/views/my/feedback")
            }, {
                path: "edit",
                component: () =>
                    import ("@/views/my/feedback")
            }, {
                path: "index",
                component: () =>
                    import ("@/views/my/feedbackList")
            }]
        },
        {
            path: '/article',
            name: 'article',
            component: ParentRouter,
            children: [{
                    path: 'list',
                    component: () =>
                        import ('@/views/article/index.vue')
                },
                {
                    path: 'search',
                    component: () =>
                        import ('@/views/article/search.vue')
                },
                {
                    path: 'detail',
                    component: () =>
                        import ('@/views/article/detail.vue')
                }
            ]
        },
        {
            path: "/appointment",
            name: "appointment",
            component: ParentRouter,
            children: [{
                path: "index",
                // component: () =>
                //     import ("@/views/appointment/index")
                component: () =>
                    import ("@/views/appointment/selectproject")
            }, {
                path: "list",
                component: () =>
                    import ("@/views/appointment/list")
            }, {
                path: "selectproject",
                component: () =>
                    import ("@/views/appointment/selectproject")
            }, {
                path: "reserveTime",
                component: () =>
                    import ("@/views/appointment/reserveTime")
            }, {
                path: "summitReserve",
                component: () =>
                    import ("@/views/appointment/summitReserve")
            }, {
                path: "details",
                component: () =>
                    import ("@/views/appointment/details")
            }]
        },
        {
            path: "/emergencyContact",
            name: "emergencyContact",
            component: ParentRouter,
            children: [{
                path: "index",
                component: () =>
                    import ("@/views/my/emergencyContact")
            }, {
                path: "yzm",
                component: () =>
                    import ("@/views/my/emergencyContactyzm")
            }, ]
        },

        {
            path: '/staff',
            name: 'staff',
            component: ParentRouter,
            children: [{
                    path: 'list',
                    component: DoctorList
                },
                {
                    path: 'detail/:userId',
                    component: DoctorDetails
                },
                {
                    path: 'search',
                    component: () =>
                        import ('@/views/staff/search.vue')
                }, {
                    path: "my-doctor",
                    component: () =>
                        import ("@/views/staff/mydoctor")
                }
            ]
        },
        {
            path: '/user',
            name: 'user',
            component: ParentRouter,
            children: [{
                    path: 'login',
                    component: () =>
                        import ("@/views/user/login2")
                },
                {
                    path: 'agreement',
                    component: agreementPage
                }, {
                    path: "login2",
                    component: () =>
                        import ("@/views/user/login2")
                }, {
                    path: "regist",
                    component: () =>
                        import ("@/views/user/regist")
                }
            ]
        }, {
            path: "/EcgReport",
            name: "EcgReport",
            component: ParentRouter,
            children: [{
                path: "index",
                component: () =>
                    import ("@/views/EcgReport/index")
            }, {
                path: "details",
                component: () =>
                    import ("@/views/EcgReport/details")
            }]
        }
    ]

})
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {

     
    return originalPush.call(this, location).catch(err => err)

}

router.beforeEach((to, from, next) => {
    wxconfig.hide();
    // console.log(";;;;32132131313",from,to);
    if (to.query['__set_ck__']) {
        let urlDatadd = JSON.parse(to.query['__set_ck__']);
        // console.log(urlDatadd);
        urlDatadd.map(item => {
            let time = new Date();
            time.setTime(time.getTime() + item.maxAge * 1000);
            cookie.set(item.name, item.value, time.toGMTString());
        })
    } else {
        if (to.path.indexOf('goods-detail') == -1) {
            // if(){
            // }
            // cookie.remove("X_CXOPLUS_DK")
        }
    }
    next();
});

router.afterEach((to, from) => {
    setTimeout(function() {
        pageread.init();
        wxconfig.init();
    }, 100);
});

export default router